import { getUserRankingConfig } from '@/components/layout/header/user-menu/constant'
import {
  ERankingLevel,
  ERankingSlug,
  UserRanking,
  UserRankingFormatted,
} from '@/types/auth'

const reformatUserRanking = (
  coolClubMember: UserRanking
): UserRankingFormatted => {
  if (!coolClubMember)
    return {
      _id: '651133c0d3f87305db25d912',
      ranking_id: ERankingLevel.NEW,
      total_point: 0,
      total_point_pending: 5970,
      total_money: 0,
      history: [],
      rank_image: '',
      ranking: {
        _id: ERankingLevel.NEW,
        title: 'Thành viên mới',
        active: 1,
        slug: ERankingSlug.NEW_USER,
      },
      voucher: {
        code: '',
        description: 'Giảm 100K <br /> Tặng Túi Jeans Coolmate đơn từ 300K',
        label: 'Happy Birthday',
      },
      date_reset_ranking: getDateResetRanking() || { now: '', next: '' },
    } as unknown as UserRankingFormatted

  const rankings = getUserRankingConfig()

  const currentRanking = rankings.find((item) => {
    return (
      item.value <= coolClubMember.total_money &&
      item.max_value > coolClubMember.total_money
    )
  })

  const rankingData = { ...coolClubMember, ...currentRanking }

  let percent = 0
  percent = Math.ceil(
    ((coolClubMember.total_money - (rankingData.value ?? 0)) /
      (rankingData.max_value ?? 1)) *
      100
  )
  percent =
    Math.ceil((percent / 100) * (rankingData.coefficient_line ?? 0)) +
    (rankingData.coefficient ?? 0)

  const nextRankingValue =
    rankingData.slug === ERankingSlug.CHAMPION
      ? 0
      : (rankingData.max_value ?? 0) - rankingData.total_money

  return {
    ...rankingData,
    percent: percent > 100 ? 100 : percent,
    next_ranking_value: nextRankingValue,
    ranking_slug: rankingData.slug || '',
    rankings,
    date_reset_ranking: getDateResetRanking() || { now: '', next: '' },
    voucher: {
      code: rankingData?.voucher_birthday?.code || '',
      description: 'Giảm 100K <br /> Tặng Túi Jeans Coolmate đơn từ 300K',
      label: 'Happy Birthday',
    },
  } as UserRankingFormatted
}

export const AuthFormatter = {
  reformatUserRanking,
}

const getDateResetRanking = (): { now: string; next: string } | null => {
  const now = new Date()
  const year = now.getFullYear()

  interface Quarter {
    now: Date
    next: Date
  }

  const quarters: Quarter[] = [
    { now: new Date(`${year}-01-01`), next: new Date(`${year}-04-01`) },
    { now: new Date(`${year}-04-01`), next: new Date(`${year}-07-01`) },
    { now: new Date(`${year}-07-01`), next: new Date(`${year}-10-01`) },
    { now: new Date(`${year}-10-01`), next: new Date(`${year + 1}-01-01`) },
  ]

  const current = quarters.find((q) => now >= q.now && now < q.next)

  // format lại sang "dd/mm/yyyy"
  const formatDate = (d: Date): string => {
    const day = String(d.getDate()).padStart(2, '0')
    const month = String(d.getMonth() + 1).padStart(2, '0')
    const year = d.getFullYear()
    return `${day}/${month}/${year}`
  }

  if (!current) {
    return {
      now: formatDate(new Date()),
      next: formatDate(new Date()),
    }
  }

  return {
    now: formatDate(current.now),
    next: formatDate(current.next),
  }
}
